import { Point } from "./schemas/canvas-element";
import consts from "shared/consts";
import { frameSchema } from "./schemas/frame";
import { createElementId, getUnixTimestampUTC } from "shared/util/utils";
import * as Sentry from "@sentry/nextjs";

type FrameInitOptions = {
  width?: number;
  height?: number;
  color?: string;
  index?: number;
};

const defaultWidth = 100;
const defaultHeight = 100;
const defaultColor = "#FFFFFF";

export function placeFrame(point: Point, init: FrameInitOptions) {
  const { width = defaultWidth, height = defaultHeight, index, color = defaultColor } = init;
  const id = createElementId();
  const base = {
    type: consts.CANVAS_ELEMENTS.FRAME,
    id,
    x: point.x,
    y: point.y,
    width,
    height,
    fill: color,
    title: `Frame ${index ?? ""}`,
    zIndexLastChangeTime: getUnixTimestampUTC(),
  };

  try {
    const frame = frameSchema.parse(base);
    return { id, frame };
  } catch (error) {
    Sentry.captureException(error, { tags: { type: "place-frame" } });
    throw error;
  }
}
